var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"l-stacked-grid l-stacked-grid--right"},[_c('div',{staticClass:"l-stacked-grid__item"},[_c('div',{staticClass:"c-sortable-list__button",on:{"click":_vm.click}},[_vm._v(" "+_vm._s(_vm.$t(_vm.i18n))+" "),_c('div',{staticClass:"o-button o-button--round icon-plus"})])]),_c('div',{staticClass:"l-stacked-grid__item"})])
}
var staticRenderFns = []

export { render, staticRenderFns }